export const LINK_SEARCH_REQUEST = 'links/LINK_SEARCH_REQUEST'
export const LINK_SEARCH_SUCCESS = 'links/LINK_SEARCH_SUCCESS'
export const LINK_SEARCH_FAILURE = 'links/LINK_SEARCH_FAILURE'

export const SHOW_LINK_EDITOR = 'links/SHOW_LINK_EDITOR'
export const HIDE_LINK_EDITOR = 'links/HIDE_LINK_EDITOR'
